import { render } from "./TheFleet.vue?vue&type=template&id=5c29123b"
import script from "./TheFleet.vue?vue&type=script&lang=js"
export * from "./TheFleet.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__